import { __extends } from "tslib";
import * as React from 'react';
import { DeprecatedLinkButton } from '../../deprecated-buttons/deprecated-link-button/link-button';
import { DeprecatedButton } from '../../deprecated-buttons/deprecated-button/button';
import { namespacedClassnames } from '../../../common/namespace-classes';
import { backArrowIcon } from './back-arrow.icon';
import { Icon } from '../../icon/icon';
import { closeX } from './close-x.icon';
import * as PropTypes from 'prop-types';
var ModalHeader = /** @class */ (function (_super) {
    __extends(ModalHeader, _super);
    function ModalHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleBackClick = function () {
            if (_this.props.onBack) {
                _this.props.onBack();
            }
        };
        _this.handleCloseClick = function () {
            if (_this.context.onDismiss) {
                _this.context.onDismiss();
            }
        };
        return _this;
    }
    ModalHeader.prototype.render = function () {
        var classNames = namespacedClassnames('modal-header');
        var maybeBackButton = this.props.onBack ?
            React.createElement(DeprecatedLinkButton, { onClick: this.handleBackClick },
                React.createElement(Icon, { icon: backArrowIcon })) : null;
        var maybeCloseButton = this.context.onDismiss && !this.context.hideCloseButton ? (React.createElement(DeprecatedButton, { className: 'close-btn', onClick: this.handleCloseClick },
            React.createElement(Icon, { icon: closeX }))) : null;
        return (React.createElement("div", { className: classNames },
            React.createElement("div", { className: 'header-back-button-wrapper' }, maybeBackButton),
            React.createElement("div", { className: 'header-content' }, this.props.children),
            React.createElement("div", { className: 'header-close-button-wrapper' }, maybeCloseButton)));
    };
    ModalHeader.contextTypes = { onDismiss: PropTypes.func, hideCloseButton: PropTypes.bool };
    return ModalHeader;
}(React.Component));
export { ModalHeader };
//# sourceMappingURL=modal-header.js.map